import { endpoints } from "src/utils";
import { createListHook } from "src/actions/utils/create-action";

/**
 * Hook to fetch current user's accessible stores
 * @param {Object} args - Fetch arguments (params, config, etc.)
 * @returns {Object} { data, loading, error, validating, empty, refresh }
 */
export const useGetMyStores = createListHook(endpoints.me.stores);
